import { Api } from "../axios.config";

const path = "/authentications";

export const getAuthentications = () => Api.get(path);
export const createAuthentication = (payload) => Api.post(path, payload);
export const updateAuthentication = (id, payload) =>
  Api.put(`${path}/${id}`, payload);
export const deleteAuthentication = (id) => Api.delete(`${path}/${id}`);
